export const getEmployee = (state, id) => {
    return (state.lampState.employees.hasOwnProperty(id)) ? state.lampState.employees[id] : null;
}